import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { CheckIn } from './check-in-kiosk-feature-check-in.actions';
import { getCheckInState } from './check-in-kiosk-feature-check-in.selectors';

@Component({
  selector: 'frontend-check-in-routed',
  templateUrl: './check-in-kiosk-feature-check-in-routed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CheckInRoutedComponent {
  state$: any;

  constructor(private store: Store<any>) {
    this.state$ = this.store.pipe(select(getCheckInState));
  }

  onSave(data) {
    this.store.dispatch(new CheckIn(data));
  }
}
